
import { Site } from "./types";

// Helper function to get review URL based on site name
export const getReviewUrlForSite = (siteName: string): string | undefined => {
  const reviewUrls: Record<string, string> = {
    "SAS Bellé recyclage": "https://g.co/kgs/zPTkTbg",
    "Centre de Bellé recyclage": "https://g.co/kgs/zPTkTbg",
    "Casse Auto du Bassin": "https://g.co/kgs/6AwYkLz",
    "Lescout Recyclage": "https://g.co/kgs/W73veAx",
    "Briane Jean Récupération": "https://g.co/kgs/BxyGhHY",
    "Centre de Briane Jean Récupération": "https://g.co/kgs/BxyGhHY",
    "Fabrude Recyclage": "https://g.co/kgs/XDtUQhZ",
    "Profit recyclage": "https://g.co/kgs/HCc4juY",
    "RM Recyclage": "https://g.co/kgs/5kKLPMY",
  };
  
  return reviewUrls[siteName];
};

// Helper function to get website URL based on site name
export const getWebsiteUrlForSite = (siteName: string): string | undefined => {
  const websiteUrls: Record<string, string> = {
    "SAS Bellé recyclage": "https://www.bellerecyclage.fr/",
    "Centre de Bellé recyclage": "https://www.bellerecyclage.fr/",
    "Casse Auto du Bassin": "https://www.opisto.fr/fr/casses-automobile/details/4281?srsltid=AfmBOoopDbr3Fg25pygiLS-CuAlFWWJoq2x7RwRVYt30OYTraEFH13SB",
    "Lescout Recyclage": "https://lescout-recyclage.fr/",
    "Briane Jean Récupération": "https://www.briane-jean.fr/",
    "Centre de Briane Jean Récupération": "https://www.briane-jean.fr/",
    "Fabrude Recyclage": "https://fabrude-recyclage.fr/",
    "Profit recyclage": "https://bennesprofit.com/",
    "RM Recyclage": "https://r-m-recyclage.fr/",
    "Carmausine de récupération": "https://www.carmausinederecuperation.fr/",
  };
  
  return websiteUrls[siteName];
};

// Map from database model to frontend model
export const mapDbToSite = (dbSite: any): Site => ({
  id: dbSite.id,
  name: dbSite.name,
  address: dbSite.address,
  city: dbSite.city,
  postalCode: dbSite.postal_code,
  phone: dbSite.phone || "",
  email: dbSite.email,
  coordinates: {
    lat: Number(dbSite.latitude),
    lng: Number(dbSite.longitude),
  },
  services: dbSite.services || [],
  description: dbSite.description || "",
  opening_hours: dbSite.opening_hours || {},
  // Add custom properties for specific sites
  reviewUrl: getReviewUrlForSite(dbSite.name),
  websiteUrl: getWebsiteUrlForSite(dbSite.name),
});
